import { render, staticRenderFns, recyclableRender, components } from "./t-city.vue?vue&type=template&id=cb009bc2&scoped=true&"
var renderjs
import script from "./t-city.vue?vue&type=script&lang=js&"
export * from "./t-city.vue?vue&type=script&lang=js&"
import style0 from "./t-city.vue?vue&type=style&index=0&id=cb009bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb009bc2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/t-city.vue"
export default component.exports